<script setup lang="ts">
import type { SuggestionProps } from "@tiptap/suggestion";
import type { EmojiEntry } from "../../emojis/data";
import { computed } from "vue";
import { searchIndex } from "../../emojis";
import { emojiIndex } from "../../emojis/data";
import { getPreferredSkinToneEmojiVariant } from "../../emojis/utils";
import { useProvideSuggestionContext } from "../suggestions";
import SuggestionList from "../suggestions/SuggestionList.vue";
import EmojiListSearchItem from "./EmojiSearchListItem.vue";

const props = defineProps<SuggestionProps>();

const searchResults = computed(() => {
  const limit = 10;
  if (!props.query) return emojiIndex.OrderedEmojis.slice(0, limit);
  return searchIndex.search(props.query, { limit }).map(d => d.item);
});

const {
  selected,
  selectedIndex,
  select,
  onKeyDown,
  onBeforeExit,
} = useProvideSuggestionContext(searchResults);

function selectItem(emojiEntry: EmojiEntry) {
  props.command({
    id: emojiEntry.id,
    native: getPreferredSkinToneEmojiVariant(emojiEntry).native,
  });
}

selected.on(index => {
  const result = searchResults.value[index];
  if (result) {
    selectItem(result);
  }
});

defineExpose({
  onKeyDown,
  onBeforeExit,
});
</script>

<template>
  <SuggestionList
    v-bind="$props"
  >
    <EmojiListSearchItem
      v-for="(result, index) in searchResults"
      :key="result.id"
      :item="result"
      :data-highlighted="selectedIndex === index ? '' : undefined"
      @pointermove="select(index)"
      @click="selectItem(result)"
    />
  </SuggestionList>
</template>
